import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

import { TitleStyle } from ".";

const container = styled.h3<{ titleStyle: TitleStyle }>`
  ${setFontStyle("Head6", "Bold")};
  margin-bottom: 24px;

  ${mobile(css`
    margin-bottom: 0;
    padding: 16px;
  `)}

  ${(props) => {
    switch (props.titleStyle) {
      case "default": {
        return css`
          color: ${COLOR.grayScale_800};
        `;
      }

      case "section": {
        return css`
          color: ${COLOR.primaryBlue};

          ${mobile(css`
            padding: 0;
          `)}
        `;
      }
    }
  }}
`;

export default {
  container,
};
